// Announcement bar js
function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function checkCookie() {
    var c_news = getCookie("announcement_close");
    if (c_news == "Reviewd") {
        document.querySelector('.shopify-section--announcement-bar').classList.add('hide');
        document.querySelector('.announcement-bar').classList.add('hide');
    } else {
        if(document.querySelector('.shopify-section--announcement-bar')) {
            document.querySelector('.shopify-section--announcement-bar').classList.remove('hide');
        }
        if( document.querySelector('.announcement-bar')) {
            document.querySelector('.announcement-bar').classList.remove('hide');
        }

        var closeBtn = document.querySelector('.close-announcementbar');
        if(closeBtn) {
            closeBtn.addEventListener('click', function () {
                document.querySelector('.shopify-section--announcement-bar').classList.add('hide');
                document.querySelector('.announcement-bar').classList.add('hide');
                setCookie('announcement_close', 'Reviewd', 365);
            });
        }
    }
}

checkCookie();

// Footer accordian js
document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth < 641) {
      var collepseButtons = document.querySelectorAll('.collepse');
  
      for (var i = 0; i < collepseButtons.length; i++) {
        collepseButtons[i].addEventListener('click', function(event) {
          var dropDown = this.closest('.footer__block').querySelector('.collpase-block');
          var allCollapseBlocks = this.closest('.footer__block-list').querySelectorAll('.collpase-block');
  
          // for (var j = 0; j < allCollapseBlocks.length; j++) {
          //   if (allCollapseBlocks[j] !== dropDown) {
          //     allCollapseBlocks[j].style.display = 'none';
          //   }
          // }
  
          if (this.classList.contains('active')) {
            this.classList.remove('active');
          } else {
            var activeCollepse = this.closest('.footer__block-list').querySelector('.collepse.active');
            if (activeCollepse) {
              activeCollepse.classList.remove('active');
            }
            this.classList.add('active');
          }
  
          // if (dropDown.style.height === 'max-content') {
          //   dropDown.style.height = 0;
          // } else {
          //   dropDown.style.height = 'max-content';
          // }
  
          event.preventDefault();
        });
      }
    }
  });
  
  var readmore = document.querySelector('#read-more-legal');
  if(readmore){
  readmore.addEventListener('click', function () {
    if(document.querySelector('.page-content').classList.contains('open')){
      readmore.innerHTML = 'Ver más';
    } else{
      readmore.innerHTML = 'Ver menos';
      
    }
  });
}

var photoSliderArticle = document.querySelector('.js-photo-slider');

if(photoSliderArticle){
  var flkty = new Flickity( photoSliderArticle, {
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    autoPlay: 2500,
    prevNextButtons: true,
    freeScroll: true,
    pageDots: false,
    on: {
      ready: function() {
        let mainWrapper = this.element.closest('.js-slider-wrapper');
        mainWrapper.querySelector('.btn_prev').addEventListener('click',() => {
          this.previous();
        });
        mainWrapper.querySelector('.btn_next').addEventListener('click',() => {
          this.next();
        });
      },
      select: function(index) {
        let mainWrapper = this.element.closest('.js-slider-wrapper');
        let slideNumber = index + 1;
        let zeroSlide = ``;
        if(this.slides.length < 10){
           zeroSlide = `0`;
        }
        let htmlTotal = `<span>${zeroSlide}${this.slides.length}</span>`,
            sildeNumberHTml = `<span class="number">${zeroSlide}${slideNumber}</span>`;
            mainWrapper.querySelector('.count_number').innerHTML = `${sildeNumberHTml} / ${htmlTotal}`;    
      }
    }
  });
  

// //Slide Count Index
//   var flktyCount = new Flickity('.photo_slider');
//   var carouselStatus = document.querySelector('.count_number');
//   function updateCount() {
    
//   }
//   updateCount();  
//   flktyCount.on( 'select', updateCount );
}


var twoImageslider = document.querySelector('.two_img_slider');
if(twoImageslider){
  var flkty = new Flickity( twoImageslider, {
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    autoPlay: 2000,
    prevNextButtons: false,
    freeScroll: true,
    pageDots: false,
  });
}

function adjustProductGallery() {
  var stickyBar = document.querySelector('.product-sticky-bar');
  var announcementBar = document.querySelector('.shopify-section--announcement-bar');
  var productGalleryMediaList = document.querySelectorAll('.product-gallery__carousel .product-gallery__media');
  var productGalleryCarouselList = document.querySelectorAll('.product-gallery__carousel');
  var stickyBarHeight = 0;
  if (stickyBar) {
    stickyBarHeight = stickyBar.offsetHeight;
  }
  var announcementBarHeight = 0;
  if (announcementBar) {
    var announcementBarHeight = announcementBar.offsetHeight;
  }
  var paddingTop = window.innerHeight - (stickyBarHeight + announcementBarHeight) ;
  
  if (window.innerWidth <= 699) {
      productGalleryMediaList.forEach(function(productGalleryMedia) {
          productGalleryMedia.style.paddingTop = paddingTop + 'px';
      });
      productGalleryCarouselList.forEach(function(productGalleryCarousel) {
          productGalleryCarousel.style.maxHeight = paddingTop + 'px';
      });
  } else {
      productGalleryMediaList.forEach(function(productGalleryMedia) {
          productGalleryMedia.style.paddingTop = 0;
      });
  }
}
document.addEventListener('DOMContentLoaded', adjustProductGallery);
